
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import MatchDayListItem from './MatchDayListItem.vue';
import EditMatch from './EditMatch.vue';

import { MatchDay, ScheduleState } from '../../schedule/store/models';
import { scheduleModuleName } from '@/modules/schedule/store/index';
import { Actions as ScheduleActions } from '@/modules/schedule/store/actions';
const scheduleModule = namespace(scheduleModuleName);

@Component({
  components: {
    MatchDayListItem,
    EditMatch,
  },
})
export default class MatchDayList extends Vue {

  @Prop() private matchDays!: MatchDay[];

  @scheduleModule.Action(ScheduleActions.FETCH_MATCH_DAY_MATCHES) private fetchMatchDayMatches!: (matchDayId: number) => void;

  private nearestMatchDay!: MatchDay;
  private nearestMatchDayTime!: number;

  private matchIdForEdit?: number = 0;
  private matchDayIdForEdit?: number = 0;

  private setNewMatchDayId(matchDayId: number) {
    this.matchIdForEdit = undefined;
    this.matchDayIdForEdit = matchDayId;
  }

  private setMatchId(matchId: number, matchDayId: number) {
    this.matchIdForEdit = matchId;
    this.matchDayIdForEdit = matchDayId;
  }

  public created() {
     this.findNearestMatchDay();
  }

  private isNearestMatchDay(matchDay: MatchDay) {
    if (this.nearestMatchDay !== undefined && this.nearestMatchDay.id === matchDay.id) {
      return true;
    }
  }

  private findNearestMatchDay(): void {

    const now: number = new Date().getTime();

    this.matchDays.forEach((matchDay: MatchDay) => {

       const matchDayTime = new Date(matchDay.defaultDateTime as Date).getTime();

       if (this.nearestMatchDayTime === undefined) {
         this.nearestMatchDay = matchDay;
         this.nearestMatchDayTime = matchDayTime;
       }

       if (Math.abs(now - this.nearestMatchDayTime) > Math.abs(now - matchDayTime)) {
         this.nearestMatchDay = matchDay;
         this.nearestMatchDayTime = matchDayTime;
        }
    });
  }

   private fetchAndUpdateMatchDayMatches(matchDayId: number) {
     this.fetchMatchDayMatches(matchDayId);
   }

}
